<template>
    <v-content style="background: #000">
        <v-layout justify-center>
            <v-flex shrink class="my-7 footer-text text-center">
                ©2019 VENTURE GLOBAL HOLDING. ALL RIGHTS RESERVED <br v-if="$vuetify.breakpoint.smAndDown">{{$vuetify.breakpoint.smAndDown ? '':'|'}} Powered By Kisra Co.,Ltd
            </v-flex>
        </v-layout>
    </v-content>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>
 .footer-text {
     color: #C4C4C4;
 }
</style>